export class TotalDocs {

    constructor(public totalRecords: number) { }
}
